import infoIconYellow from '@@/mixing/images/info-icon-yellow.svg';
import infoIconRed from '@@/mixing/images/info-icon-red.svg';
import { Tooltip } from 'antd';
import styles from './index.module.sass';
import { ReactNode } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { setActivesModalOpen } from '@/modules/mixing/store/analytical-mixing.store';
import infoSvg from '@@/mixing/images/info-icon.svg';
import classNames from 'classnames';
import { setSelectedRecipeStore } from '@/modules/mixing/store/recipes.store';

export const DetalisationTooltip = ({
  status,
  red,
  rangeKm,
  navigate,
  infoIcon,
  className,
  onClick,
}: {
  red?: boolean;
  rangeKm?: number;
  navigate?: NavigateFunction;
  infoIcon?: boolean;
  className?: string;
  status:
    | 'UndefinedCase'
    | 'UndefinedCaseWithComment'
    | 'NoMatchingDistanceCost'
    | 'NoValidDestinations'
    | 'BuyerPickupEnforced'
    | 'MoistureAboveTarget'
    | 'ZeroClass'
    | 'AfterChange'
    | 'Modify';
  onClick?: () => void;
}) => {
  let text: ReactNode = '';
  switch (status) {
    case 'UndefinedCase':
      text =
        'Отсутствует оценка стоимости зерна в рукаве/объеме, либо отсутствует сопоставимый оффер';
      break;
    case 'UndefinedCaseWithComment':
      text =
        'Отсутствует оценка стоимости зерна в рукаве/объеме, либо отсутствует сопоставимый оффер. Возможно, в результате усушки изменились параметры';
      break;
    case 'MoistureAboveTarget':
      text = 'Стоимость зерна не определилась из-за влажности более 14%';
      break;
    case 'NoMatchingDistanceCost':
      text = rangeKm ? (
        <span>
          Расстояние до ближайшего ППЗ (пункта приема зерна) не входит ни в один
          диапазон расчета логистики - стоимость НЕТТО посчитать невозможно. <br />
          <b>Решение:</b> увеличьте диапазон расчета логистики, от {rangeKm} км и более
          <br />
          {navigate && (
            <a
              onClick={(e) => {
                e.preventDefault();
                setActivesModalOpen({ payload: false });
                navigate('/mixing/logistics');
              }}
            >
              управление диапазонами логистики
            </a>
          )}
        </span>
      ) : (
        <span>
          Расстояние до ближайшего ППЗ (пункта приема зерна) не входит ни в один
          диапазон расчета логистики - стоимость НЕТТО посчитать невозможно. <br />
          <b>Решение: </b>увеличьте диапазон расчета логистики
          <br />
          {navigate && (
            <a
              onClick={(e) => {
                e.preventDefault();
                setActivesModalOpen({ payload: false });
                navigate('/logistics');
              }}
            >
              управление диапазонами логистики
            </a>
          )}
        </span>
      );
      break;
    case 'NoValidDestinations':
      text =
        'Для данного оффера не рассчитана дистанция до ближайшего ППЗ (ошибка расчета логистики, либо у покупателя отсутствует ППЗ)';
      break;
    case 'BuyerPickupEnforced':
      text = 'Стоимость логистики включена в стоимость предложения';
      break;
    case 'ZeroClass':
      text = 'Полученные параметры микса не входят ни в один из классов по ГОСТу';
      break;
    case 'AfterChange':
      text = 'Стоимость с учетом действий осушения/увлажнения';
      break;
    case 'Modify':
      text = (
        <span style={{ color: 'rgb(126, 137, 165)' }}>
          для соответствия указанной стоимости, необходимо осушение или увлажнение
          <br />
          {onClick && (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onClick();
              }}
            >
              подробнее
            </a>
          )}
        </span>
      );
  }

  return (
    <Tooltip title={text} color="#fff" overlayInnerStyle={{ color: '#000' }}>
      <img
        className={classNames(styles.infoIcon, className)}
        src={infoIcon ? infoSvg : red ? infoIconRed : infoIconYellow}
        alt="more info"
      />
    </Tooltip>
  );
};
